export const USE_CASE_ARTWORK = {
  "ad-to-lander": { workflow: "build-shopify-landing-page" },
  "paid-social-funnel": { workflow: "build-sales-funnel" },
  "competitor-teardown": { workflow: "research-competitor-ads" },
  "figma-to-page": { workflow: "import-shopify-figma" },
  "bundle-builder": { workflow: "build-shopify-bundle" },
  "quiz-funnel": { workflow: "build-sales-funnel" },
  "winback-machine": { workflow: "build-shopify-landing-page" },
  "sale-launcher": { workflow: "build-storefront" },
  "seasonal-promo": { workflow: "build-storefront" },
  "campaign-pages": { workflow: "build-shopify-ad-page" },
  "slide-out-cart": { workflow: "build-shopify-product-page" },
  "page-multiplier": { workflow: "copy-shopify-page" },
  "brand-personas": { workflow: "research-competitor-ads" },
  "page-audit": { workflow: "copy-competitor-page" },
  "pixel-audit": { workflow: "connect-domain" },
  "launch-checklist": { workflow: "publish-page" },
  "discount-leak-audit": { workflow: "build-shopify-product-page" },
  "ad-split-test": { workflow: "build-sales-funnel" },
  "review-carousel": { workflow: "build-shopify-product-page" },
  "case-studies-section": { workflow: "copy-shopify-page" },
  "csv-pages": { workflow: "copy-shopify-page" },
  "creator-pages": { workflow: "build-shopify-ad-page" },
  "city-pages": { workflow: "connect-domain" },
  "retail-partner-pages": { workflow: "build-storefront" },
  "comparison-pages": { workflow: "copy-competitor-page" },
  "gsc-keyword-lift": { workflow: "publish-page" },
  "programmatic-seo": { workflow: "copy-shopify-page" },
  "monday-report": { workflow: "research-competitor-ads" },
  "competitor-watch": { workflow: "research-competitor-ads" },
  "review-digest": { workflow: "research-competitor-ads" },
  "ad-congruence-check": { workflow: "build-shopify-ad-page" },
  "site-upkeep": { workflow: "publish-page" },
} as const;

export type UseCaseArtworkId = keyof typeof USE_CASE_ARTWORK;

export function isUseCaseArtworkId(slug: string): slug is UseCaseArtworkId {
  return Object.hasOwn(USE_CASE_ARTWORK, slug);
}
